import React, {useCallback, useRef} from 'react';

type FormContextProps = ReturnType<typeof useFormContextBuilder>;

export const formContext = React.createContext<FormContextProps>({
   passThrough: null,
   registerLabel: (name: string, label?: string) => {
      console.error('registerLabel - Not implemented');
   },
   registered: {} as RegisteredLabel, //[] as RegisteredLabel[],
   triggerSubmit: () => {
      console.error('triggerSubmit - Not implemented');
   },
   formRef: {current: null},
});

type FormContextProviderProps = {
   value: FormContextProps;

   children: React.ReactNode;
};

export const useRegisterLabel = (name: string, label?: string) => {
   const {registerLabel} = React.useContext(formContext);
   React.useEffect(() => {
      registerLabel(name, label);
   }, [registerLabel, name, label]);
};

export const useTriggerSubmitForm = () => {
   const {triggerSubmit} = React.useContext(formContext);
   return triggerSubmit;
};

export function usePassThroughProps<T>() {
   const {passThrough} = React.useContext(formContext);
   return passThrough as T;
}

type RegisteredLabel = {[name: string]: string | undefined};

export const useFormContextBuilder = (passThrough?: any) => {
   // const [registered, setRegistered] = React.useState<RegisteredLabel>({});
   const registeredRef = React.useRef({} as RegisteredLabel);
   // registeredRef.current = registered;
   // const registered = {} as RegisteredLabel;

   const registerLabel = React.useCallback(
      (name: string, label?: string) => {
         // const newRegistered = {...registeredRef.current, [name]: label};
         // setRegistered(newRegistered);
         registeredRef.current[name] = label;
         // console.debug('register', name, label, registeredRef.current);
      },
      [registeredRef]
   );

   const formRef = useRef<HTMLFormElement | null>();
   const triggerSubmit = useCallback(() => {
      formRef.current?.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}));
   }, [formRef]);

   return {
      passThrough,
      registered: registeredRef.current,
      registerLabel,
      triggerSubmit,
      formRef: formRef as React.MutableRefObject<HTMLFormElement | null>,
   };
};

export const FormContextProvider = ({value, children}: FormContextProviderProps) => {
   const {Provider} = formContext;
   return <Provider value={value}>{children}</Provider>;
};
